import { MoveRight } from "lucide-react";
import React, {createContext} from 'react';

interface gmailStatus {
    gsiLoaded: boolean,
    gapiLoaded: boolean,
    authenticated: boolean,
    isAuthenticating: boolean
}

export const origStatus: gmailStatus = {
    gsiLoaded: false,
    gapiLoaded: false,
    authenticated: false,
    isAuthenticating: false
}

export const GmailContext = createContext<any>({} as any);

// var gsiLoaded: boolean = false;
// var gapiLoaded: boolean = false;
// export var authenticated: boolean = false;
// export var isAuthenticating: boolean = false;

// export function handleGapiLoad() {
//     console.log("gapi loaded");
//     window.gapi.load('client', () => {
//         window.gapi.client.init({
//             apiKey: ""
//             discoveryDocs: ["https://gmail.googleapis.com/$discovery/rest?version=v1"]
//         })
        // .then(() => {
        //     gapiLoaded = true;
        // });
//     });
// }

// export function handleGsiLoad() {
//     gsiLoaded = true;
// }

function getToken(callback: Function) {
    console.log("doing stuff");
    var client = window.google.accounts.oauth2.initTokenClient({
        client_id: import.meta.env.VITE_GOOGLE_CLIENTID,
        scope: 'https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.compose',
        prompt: "select_account",
        callback: callback
        // callback: (response: any) => {
        //     if (response.error !== undefined) {
        //         throw (response);
        //     }
        //     console.log("finished authentication!!");
        //     authenticated = true;
        //     console.log("var stat:");
        //     console.log(authenticated);
        // }
    })
    client.requestAccessToken()
}

export type MessageForm = {
    recipient: String, subject: String, text: String
}


export function authenticate(callback: Function) {
    // isAuthenticating = true;
    if (window.gapi.client.getToken() === null) {
        // authenticated = false;
        getToken(callback);
    } else {
        console.log("authenticated");
    }
    // isAuthenticating = false;
}

export function sendEmail(messageform: MessageForm) {
    const email = `To: ${messageform.recipient}\r\nSubject: ${messageform.subject}\r\n\r\n${messageform.text}`
    // console.log(email);
    const message: gapi.client.gmail.Message = {
        raw: window.btoa(email).replace(/\+/g, '-').replace(/\//g, '_')
    }
    // console.log(message);
    window.gapi.client.gmail.users.messages.send({
        resource: message,
        userId: "me"
    }).then(() => {console.log("sent!")});
}

